export default __webpack_public_path__ + "static/media/fastingfatburn@3x.428528b6.jpg";